<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}<span class="page_title_value"> {{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n5">
                            <v-autocomplete
                            outlined
                            label="Year"
                            type="text"
                            ref="year"
                            hide-selected
                            v-model="formData.year"
                            dense
                            :items="yearList"
                            :rules="[rules.required]"
                            clearable
                            ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="10" class="mt-n8">
                        <v-autocomplete
                            outlined
                            :label="this.$t('columns.staffname')"
                            type="text"
                            dense
                            :items="staffDetailsList"
                            v-model="formData.staffid"
                            :rules="[rules.required]"
                        ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="4" class="mt-n8">
                        <v-autocomplete
                            outlined
                            background-color="#ffeab2"
                            :label="this.$t('columns.staffcode')"
                            dense
                            v-model="formData.staffid"
                            :items="staffIdList"
                            hide-selected
                            readonly
                            append-icon=""
                        ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="4" class="mt-n8">
                        <v-autocomplete
                            outlined
                            background-color="#ffeab2"
                            :label="this.$t('columns.company')"
                            dense
                            v-model="formData.staffid"
                            :items="staffCompanyList"
                            hide-selected
                            readonly
                            append-icon=""
                        ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col col="12" sm="12" class="pb4-4">
                            <app-table 
                                v-bind:parentObject = "{
                                    tabHeader: this.tabHeader,
                                    detailItem: this.formData.eaaddondetail
                                }"

                                v-on:input="addItemHandler"
                                v-on:error="errorHandler"
                            />
                        </v-col>
                    </v-row>

                </v-container>


                <app-formbuttons
                    v-bind:EditBool = this.parentObject.isEdit

                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler"
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler"
                />

            </v-form>

        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';

export default {
    props: {
        parentObject: Object,
       // timeHolder: Object
    },

    components: {
        'app-table': CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },
            formData: {
                id: this.parentObject.data.id,
                eaaddondetail: this.parentObject.data.eaaddondetail,
                year: this.parentObject.data.year,
                staffid: this.parentObject.data.staffid,

                search: this.parentObject.data.search,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },
            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.code'), value: 'col', width: '100px', sortable: false},
                { text: this.$t('columns.col'), value: 'coldesc', width: '200px', sortable: false},
                { text: this.$t('columns.description'), value: 'replacement', width: '200px', sortable: false}
    
            ],
            
            years: [],
            yearList: [],
            staffDetailsList: [],
            staffIdList: [],
            staffCompanyList: [],

            errMsg: '',
            isErr: false,
            search: this.parentObject.searchnew

        }
    },

    methods: {

        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
            this.$emit('error', {isErr: this.isErr, errMsg: this.errMsg});
        },

        addItemHandler($event) {
            this.formData.eaaddondetail =$event
        },

        loadYear(){
            const vm = this;

            this.$store.dispatch('get', {url: '/payoutctrl/all'})
                .then(res => {
                    vm.years = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.yearList.push(
                            {
                                text: res.data.rec[i].pyyear,
                                value: res.data.rec[i].pyyear
                            }
                        )                        
                    }

                    if (vm.formData.pyyear) {
                        vm.changeYearHandler(vm.formData.pyyear);
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

        changeYearHandler(id) {
            this.years.find(item => item.id === id);
            
        },

        loadStaffDetailsListHandler() {
            const vm = this;

            this.$store.dispatch('get', {url: `/staff/all/${this.$store.getters.userId}`})
                .then((res) => {
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.staffDetailsList.push({
                    text: res.data.rec[i].psndetails,
                    value: res.data.rec[i].id,
                    });
                }

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.staffIdList.push({
                    text: res.data.rec[i].staffcode,
                    value: res.data.rec[i].id,
                    });
                }

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.staffCompanyList.push({
                    text: res.data.rec[i].compnyname,
                    value: res.data.rec[i].id,
                    });
                }
            })
                .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },



        updateValue() {

        this.$emit('input', {

                id: this.formData.id,
                eaaddondetail: this.formData.eaaddondetail,

                year: this.formData.year,
                staffid: this.formData.staffid,

                search: this.formData.search,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.updateValue();
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'eadtllist', params: { search: this.search}});
        },

    },

    async mounted() {
        await this.loadYear();
        await this.loadStaffDetailsListHandler();
    }



}
</script>

<style>
.v-toolbar__content {
  padding-left: 0px;
}
.vue__time-picker {
  width: 100% !important;
}
.time-picker {
  height: 40px !important;
  width: 100% !important;
  /* border: thin solid currentColor; */
  border-radius: 5px;
}
</style>